module.exports = __webpack_public_path__ + "static/0b5ae0a33101ef60e1214a3c98d73e5a99cc2c401b9360e2eaa3a32e91bab75a-414286f0f77406c81a87807d75128a20.png";